<template>
  <div class="pointer-events-none absolute inset-0 z-0 overflow-visible">
    <div
      v-for="shape in shapes"
      :key="shape.shape"
      class="animate-elliptical-orbit transform-ellipse absolute top-1/2 left-1/2"
      :style="{
        '--radius-x': '26px',
        '--radius-y': '5px',
        '--ellipse-rotate': shape.rotate,
        // Negative delay starts each shape already partway around the ellipse
        animationDelay: `-${shape.delay}`,
      }"
    >
      <BaseShape
        class="animate-rotate absolute top-0 left-0 h-4 w-4 -translate-x-1/2 -translate-y-1/2"
        :class="shape.classes"
        :shape="shape.shape"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseShape from '../base/shapes/BaseShape.vue'

  const shapes = [
    {
      shape: 'pill',
      delay: '0ms',
      rotate: '0deg',
      classes: 'text-secondary-container',
    },
    {
      shape: 'triangle',
      delay: '700ms',
      rotate: '45deg',
      classes: 'text-tertiary-container',
    },
    {
      shape: 'puffy diamond',
      delay: '1500ms',
      rotate: '90deg',
      classes: 'text-primary-container',
    },
    {
      shape: 'burst',
      delay: '3750ms',
      rotate: '135deg',
      classes: 'text-outline-variant',
    },
  ] as const
</script>
